import type { FetchEnrichedSupplierParams } from '@bridebook/toolbox/src/supplier/enrich/types';
import type { IEnrichedSupplier } from '@bridebook/toolbox/src/supplier/types';
import { fetchy } from '@bridebook/web/lib/fetchy';

/**
 * @param publicId Supplier publicId
 * @param {FetchEnrichedSupplierParams} bodyParams - object to pass with POST body
 * @returns {IEnrichedSupplier}
 */
export const fetchSupplierPromise = (
  publicId: string,
  bodyParams?: FetchEnrichedSupplierParams,
): Promise<IEnrichedSupplier> =>
  fetchy().post('/api/supplier/[id]', { id: publicId }, bodyParams ?? {});
